var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResetRotation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1C8.89543 1 8 1.89543 8 3V4.26756C8.29417 4.09739 8.63571 4 9 4H27C27.3643 4 27.7058 4.09739 28 4.26756V3C28 1.89543 27.1046 1 26 1H10ZM29 6V3C29 1.34315 27.6569 0 26 0H10C8.34315 0 7 1.34315 7 3V6V10.9582C7.00063 10.9871 7.00063 11.016 7 11.0449V15.6698C7.31715 15.7626 7.65052 15.8526 8 15.939V6C8 5.44772 8.44772 5 9 5H27C27.5523 5 28 5.44772 28 6V15.939C28.3498 15.8525 28.6832 15.7625 29 15.6698V11.0449C28.9994 11.016 28.9994 10.9871 29 10.9582V6ZM8 20.0438C7.65685 19.97 7.32348 19.8927 7 19.8122V25V31C7 32.6569 8.34315 34 10 34H26C27.6569 34 29 32.6569 29 31V25V19.8122C28.6763 19.8927 28.343 19.97 28 20.0438V25C28 25.5523 27.5523 26 27 26H9C8.44772 26 8 25.5523 8 25V20.0438ZM28 26.7324V31C28 32.1046 27.1046 33 26 33H10C8.89543 33 8 32.1046 8 31V26.7324C8.29417 26.9026 8.63571 27 9 27H27C27.3643 27 27.7058 26.9026 28 26.7324ZM20 30C20 31.1046 19.1046 32 18 32C16.8954 32 16 31.1046 16 30C16 28.8954 16.8954 28 18 28C19.1046 28 20 28.8954 20 30ZM18 31C18.5523 31 19 30.5523 19 30C19 29.4477 18.5523 29 18 29C17.4477 29 17 29.4477 17 30C17 30.5523 17.4477 31 18 31Z",
    fill: "#0071FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 11C32.3333 11.3333 35 12.4 35 14C35 15.7764 30.2664 18.3418 21.5 18.8931",
    stroke: "#0071FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 11C3.66667 11.3333 1 12.4 1 14C1 16 7 19 18 19",
    stroke: "#0071FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 15L18 19L14 23",
    stroke: "#0071FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetRotation);
export default __webpack_public_path__ + "static/media/resetRotation.4da677ed46bfe71237b1bda0b0961c49.svg";
export { ForwardRef as ReactComponent };